import React, { createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Initialize Stripe with the publishable key from environment variables
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// Create the Stripe context
const StripeContext = createContext();

// Custom hook to use the Stripe context
export const useStripe = () => {
  return useContext(StripeContext);
};

// Stripe Provider Component
export const StripeProvider = ({ children }) => {
  // Options for the Stripe Elements
  const options = {
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#5E17EB',
        colorBackground: '#ffffff',
        colorText: '#434343',
        colorDanger: '#ff5252',
        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      },
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <StripeContext.Provider value={{ stripePromise }}>
        {children}
      </StripeContext.Provider>
    </Elements>
  );
};

export default StripeProvider; 